import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des fichiers de traduction
import translationFR from './locales/fr.json';
import translationEN from './locales/en.json';

// Définition des ressources de traduction
const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
};

// Initialisation de i18n
i18n
  .use(LanguageDetector) // détecte automatiquement la langue
  .use(initReactI18next) // intègre i18n à React
  .init({
    resources,
    fallbackLng: 'fr', // langue par défaut
    debug: false,
    keySeparator: false, // ne pas séparer les clés par des points
    interpolation: {
      escapeValue: false, // React s'occupe déjà de l'échappement
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'], // ordre de détection
      caches: ['localStorage'], // mémoriser la langue choisie
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true,
    },
    whitelist: ['fr', 'en'], // langues autorisées
    load: 'currentOnly', // charge uniquement la langue principale (fr, en)
    react: {
      useSuspense: false, // éviter le fallback infini si traduction non chargée
    },
  });

export default i18n;
